'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NETWORK_OFFLINE_ALERT_ID = exports.NETWORK_OFFLINE_ALERT_ID = 'network-offline-alert';
var RECONNECTED_ALERT_ID = exports.RECONNECTED_ALERT_ID = 'reconnected-alert';
var RESUBSCRIBE_LIMIT_REACHED_ALERT_ID = exports.RESUBSCRIBE_LIMIT_REACHED_ALERT_ID = 'resubscribe-limit-reached-alert';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/connection-alerts/constants/alertTypes.js
// module id = 264
// module chunks = 2 3